import React, { useState } from 'react';

// 上記で定義したcategorizedFaqsデータをここに貼り付けます
const categorizedFaqs = [
  {
    category: '入学について',
    id: 'admission',
    questions: [
      {
        id: 'q_admission_1',
        question: 'Q:前籍校で習得した単位や在籍期間はどのようになりますか？',
        answer: 'A:前籍校で修得した単位・在籍期間は、原則認められます。詳しくはお問い合わせください。'
      },
      {
        id: 'q_admission_2',
        question: 'Q:現在、他の高校に通っているのですが、いつから転校できますか？',
        answer: 'A:転校は随時可能です。まずは在籍している高等学校の先生にご相談ください。'
      },
      {
        id: 'q_admission_3',
        question: 'Q:現在ほとんど学校に通えていません。入学することはできますか？',
        answer: 'A:TOSAYOBI高等学院には不登校を経験したなどさまざまな事情や背景を持った方も受け入れております。自分のペースに合ったコースや時間割を選択できるなど、一人ひとりに合ったサポートをしていきます。不安な点がありましたら、お気軽にご相談ください。'
      },
    ]
  },
  {
    category: '学習・授業について',
    id: 'learning',
    questions: [
      {
        id: 'q_learning_1',
        question: 'Q:学力に自信がなくても学習についていけますか？',
        answer: 'A:希望者には中学校の内容から学習を始められるのでご安心ください。一人ひとりの目的・理解度に合わせて学ぶことができるので、分かるところから始めていきましょう。'
      },
      {
        id: 'q_learning_2',
        question: 'Q:勉強する科目をどのように決めていけばよいか不安です。',
        answer: 'A:キャンパスの教員と相談しながら無理のないカリキュラムを組んでいきますので、ご安心ください。'
      },
      {
        id: 'q_learning_3',
        question: 'Q:コースは一度決めたら変えられませんか？',
        answer: 'A:途中からでも変更可能です。'
      },
      {
        id: 'q_learning_4',
        question: 'Q:TOSAYOBI高等学院の学習はどのように行われますか？',
        answer: 'A:単位を取得するための内容として、映像授業の視聴とレポート制作を行い、進学を希望する生徒には大学受験に対応できる内容を一人ひとりに合わせて指導していきます。'
      },
    ]
  },
  {
    category: 'TOSAYOBI高等学院での生活について',
    id: 'life',
    questions: [
      {
        id: 'q_life_1',
        question: 'Q:中学校を休みがちでした。きちんと通えるか不安です。',
        answer: 'A:一人ひとりの状況に合わせたサポートしますので、ご安心ください。'
      },
      {
        id: 'q_life_2',
        question: 'Q:校則はありますか？',
        answer: 'A: 特にありません。'
      },
      {
        id: 'q_life_3',
        question: 'Q:制服はありますか？',
        answer: 'A：制服はありますが、希望制となっており服装は自由です。'
      },
      {
        id: 'q_life_4',
        question: 'Q:特別活動とは？',
        answer: 'A:養父本校でのスクーリングの際に行う授業でのことで、わら細工、紙すき体験など普段体験することのないことを学びます。'
      },
    ]
  },
];

function QuestionHighSchool() {
  // どの質問が開いているかを管理するState
  // { categoryId: questionId } の形式で、各カテゴリで開いている質問を管理
  // もしくは、一意の質問IDを直接配列に入れる形でもOK
  const [openQuestionId, setOpenQuestionId] = useState(null);

  const toggleAnswer = (questionId) => {
    // クリックされた質問が既に開いている場合は閉じる
    // そうでなければ、その質問を開く
    setOpenQuestionId(openQuestionId === questionId ? null : questionId);
  };

  return (
    <section className='py-20 bg-gray-100'> {/* 背景色を付けて見やすく */}
      <h2 className='text-6xl text-black text-center mb-16'>
        よくある質問
      </h2>
      <div className='w-3/4 mx-auto'>
        {categorizedFaqs.map((categoryData) => (
          <div key={categoryData.id} className='mb-12'> {/* カテゴリごとの間隔 */}
            <h3 className='text-4xl font-bold text-red-800 border-b-4 border-red-800 pb-4 mb-8'>
              {categoryData.category}
            </h3>
            <div className='bg-white rounded-lg shadow-lg overflow-hidden'>
              {categoryData.questions.map((faq) => (
                <div key={faq.id} className='border-b border-gray-200 last:border-b-0'>
                  {/* 質問部分 - クリック可能にする */}
                  <button
                    className='w-full text-left p-6 flex justify-between items-center cursor-pointer focus:outline-none transition-colors duration-200 hover:bg-gray-50'
                    onClick={() => toggleAnswer(faq.id)}
                  >
                    <p className='text-black text-2xl font-bold'> {/* フォントサイズを調整 */}
                      {faq.question}
                    </p>
                    {/* 開閉を示すアイコン */}
                    <svg
                      className={`w-7 h-7 text-gray-500 transition-transform duration-300 ${
                        openQuestionId === faq.id ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                  </button>

                  {/* 回答部分 - 条件付きで表示 */}
                  {openQuestionId === faq.id && (
                    <div className='px-6 pb-6 pt-2 bg-gray-50 transition-all duration-300 ease-in-out'>
                      <p className='text-gray-700 text-xl leading-relaxed text-left'> {/* フォントサイズを調整 */}
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default QuestionHighSchool;